import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { FundManagementRoutingModule } from '@app/modules/fund-management/fund-management-routing.module';
import { SharedModule } from '@app/shared';
import { EmployeeSearchModule } from '@app/shared/components/employee-search/employee-search.module';
import { UserListService } from './account-user/services/user-list-service';
import { UserListControlComponent } from './account-user/user-list-control.component';
import { UserListComponent } from './account-user/user-list.component';
import { AccountsPayableModule } from './accounts-payable/accounts-payable.module';
import { ImportPcardComponent } from './accounts-payable/import-pcard/components/import-pcard/import-pcard.component';
import { ImportPcardService } from './accounts-payable/import-pcard/services/import-pcard.service';
import { SalesTaxInvoiceParamsComponent } from './accounts-payable/sales-tax-invoice-params/sales-tax-invoice-params.component';
import { SalesTaxInvoiceParamsFormService } from './accounts-payable/sales-tax-invoice-params/services/sales-tax-invoice-params.service';

@NgModule({
	imports: [
		CommonModule,
		MatDialogModule,
		SharedModule,
		FundManagementRoutingModule,
		EmployeeSearchModule,
		AccountsPayableModule,
		ImportPcardComponent,
		SalesTaxInvoiceParamsComponent,
		UserListComponent,
		UserListControlComponent,
	],
	providers: [ImportPcardService, SalesTaxInvoiceParamsFormService, UserListService],
})
export class FundManagementModule {}
